import type { ComponentProps } from 'react';
import React from 'react';

import { ProductCardDetails } from './ProductCardDetails';
import { ProductCardDetailsV2 } from './ProductCardDetailsV2';

type ProductDetailsProps = ComponentProps<typeof ProductCardDetails> & { isV2: boolean };

export const ProductDetailsSection = ({ isV2, ...props }: ProductDetailsProps) => {
  return isV2 ? <ProductCardDetailsV2 {...props} /> : <ProductCardDetails {...props} />;
};
